<template>
  <div id="left-browser" ref="left-browser">
    <h2>
      {{ $t('lObjectBr') }}
    </h2>
    <p>
      <h3 id="leftBrowserSections">{{ $t('leftBrowserSections') }}</h3>
      {{ $t('offersDreamFlatTools') }}<br />
    </p>
    <div ref="favorites" class="sub-paragraph-block">
      <h3 id="favorites" ref="favorites" class="mt-5">
        {{ $t('favorites') }}
      </h3>
      <p>
        {{ $t('quicklyAccess') }}
      </p>
    <div class="paragraph-steps">
      <h4>
        {{ $t('addingModel') }}
      </h4>
      <p class="paragraph-steps-text">
        {{ $t('addingModelFavourites') }}
      </p>
      <div class="step-block">
        <p class="step-element">
          {{ $t('createFolder') }}
        </p>
        <p class="step-element">
          {{ $t('folderCreatedEarlier') }}
        </p>
        <p class="step-element">
          {{ $t('favoritesWithoutFolder') }}
        </p>
      </div>
    </div>
    </div>
    <div class="paragraph-steps">
      <h4>
        {{ $t('addingFromScene') }}
      </h4>
      <p class="paragraph-steps-text">
        {{ $t('addingFavoritesModel') }}
      </p>
      <p class="paragraph-steps-text">
        {{ $t('addingFavoritesModelInstructions') }}
      </p>
      <p class="paragraph-steps-text">
        {{ $t('addingFavoritesModelInstructions2') }}
      </p>
    </div>
    <div v-if="locale === 'ru'" class="image-carousel">
      <ImagesCustomSlider
      :height="null"
        width="100%"
        :images="[
          `${staticUrl}/images/interior-design-9.webp`,
          `${staticUrl}/images/interior-design-9-0.webp`,
        ]"
      />
    </div>
    <div v-else class="image-carousel">
      <ImagesCustomSlider
      :height="null"
        width="100%"
        :images="[
          `${staticUrl}/images/interior-design-en-9.webp`,
          `${staticUrl}/images/interior-design-en-99.webp`,
        ]"
      />
    </div>
    <div class="paragraph-steps">
      <h4>
        {{ $t('selections') }}
      </h4>
      <p class="paragraph-steps-text">
        {{ $t('useUrProjects') }}
      </p>
    </div>
    <div v-if="locale === 'ru'" class="image-carousel">
      <ImagesCustomSlider
      :height="null"
        width="100%"
        :images="[
          `${staticUrl}/images/interior-design-9-1.webp`,
          `${staticUrl}/images/interior-design-9-2.webp`,
        ]"
      />
    </div>
    <div v-else class="image-carousel">
      <ImagesCustomSlider
      :height="null"
        width="100%"
        :images="[
          `${staticUrl}/images/interior-design-en-9-1.webp`,
          `${staticUrl}/images/interior-design-en-9-2.webp`,
        ]"
      />
    </div>
    <div ref="search" class="paragraph-block">
      <h3 id="search" ref="search">
        {{ $t('search') }}
      </h3>
      <p class="mb-5">
        {{ $t('enterKeywords') }}
      </p>
      <img
        v-if="locale === 'ru'"
        :src="`${staticUrl}/images/interior-design-10.webp`"
        alt=""
        class="article-image"
      />
      <img
        v-else
        :src="`${staticUrl}/images/interior-design-en-10.webp`"
        alt=""
        class="article-image"
      />
    </div>
    <div id="materials" ref="materials" class="paragraph-block">
      <h3 id="finishingWord" class="mt-5">
        {{ $t('finishingWord') }}
      </h3>
      <p>
        {{ $t('useAnyFinishYourProject') }}
      </p>
      <div
        id="functions-of-materials-on-stage"
        ref="functions-of-materials-on-stage"
        class="sub-paragraph-block"
      >
        <h4>
          {{ $t('sceneMaterialFunctions') }}
        </h4>
        <div class="paragraph-steps">
          <div class="step-block">
            <p class="step-element">
              {{ $t('changeMaterialPosition') }}
            </p>
            <p class="step-element">
              {{ $t('triplanarTextureMapping') }}
            </p>
          </div>
          <div v-if="locale === 'ru'" class="image-carousel">
            <ImagesCustomSlider
            :height="null"
              width="100%"
              :images="[
                `${staticUrl}/images/interior-design-11-1.webp`,
                `${staticUrl}/images/interior-design-11-2.webp`,
              ]"
            />
          </div>
          <div v-else class="image-carousel">
            <ImagesCustomSlider
            :height="null"
              width="100%"
              :images="[
                `${staticUrl}/images/interior-design-en-11-1.webp`,
                `${staticUrl}/images/interior-design-en-11-2.webp`,
              ]"
            />
          </div>
          <div class="i-block">
            <div class="i-block-info">
              <div class="i-block-info-icon">
                <div class="info-icon-background">
                  <div class="info-icon-text">
                    {{ $t('i') }}
                  </div>
                </div>
              </div>
              <div class="i-block-info-text">
                {{ $t('editMaterialOnWall') }}<br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="models" ref="models" class="paragraph-block">
      <h3 id="modelsAndTheirFunctions">
        {{ $t('modelsAndTheirFunctions') }}
      </h3>
      <p>
        {{ $t('presetmodels') }}
      </p>
      <div
        id="functions-models"
        ref="functions-models"
        class="sub-paragraph-block"
      >
        <div class="paragraph-steps">
          <h4>
            {{ $t('movingRotating') }}
          </h4>
          <div class="step-block">
            <p >
              {{ $t('addInteriorObject') }}
            </p>
            <p>
              {{ $t('movedLeftRightUpDown') }}
            </p>
            <p>
              {{ $t('aroundVerticalAxis') }}
            </p>
          </div>
        </div>
        <div class="i-block">
          <div class="i-block-info">
            <div class="i-block-info-icon">
              <div class="info-icon-background">
                <div class="info-icon-text">
                  {{ $t('i') }}
                </div>
              </div>
            </div>
            <div class="i-block-info-text">
              {{ $t('positionRotationAngle') }}
            </div>
          </div>
        </div>
        <div class="paragraph-steps">
          <h4>
            {{ $t('copyingPastingObjects') }}
          </h4>
          <p>
            {{ $t('randomCopy') }}
          </p>
          <p>
            {{ $t('copyPasteObjct') }}
          </p>
        </div>
        <div class="i-block">
          <div class="i-block-info">
            <div class="i-block-info-icon">
              <div class="info-icon-background">
                <div class="info-icon-text">
                  {{ $t('i') }}
                </div>
              </div>
            </div>
            <div class="i-block-info-text">
              {{ $t('ctrlCCtrlV') }}
            </div>
          </div>
        </div>
        <p>
          {{ $t('copyAxis') }}
        </p>
        <p>
          {{ $t('copyAxisDetail') }}
        </p>
        <div class="paragraph-steps">
          <h4>
            {{ $t('grpngRttngObjectGroup') }}
          </h4>
          <p>
            {{ $t('ctrl2MoreObjects') }}
          </p>
          <p>
            {{ $t('options2RttngGrpd') }}
          </p>
          <div class="step-block">
            <p class="step-element">
              {{ $t('rotateGroupedObjects') }}
            </p>
            <p class="step-element">
              {{ $t('rotatearoundObjct') }}
            </p>
          </div>
        </div>
        <div class="i-block">
          <div class="i-block-info">
            <div class="i-block-info-icon">
              <div class="info-icon-background">
                <div class="info-icon-text">
                  {{ $t('i') }}
                </div>
              </div>
            </div>
            <div class="i-block-info-text">
              {{ $t('gnrlOptnsGrpdObjct') }}
            </div>
          </div>
        </div>
  
        <div class="paragraph-steps">
          <h4>
            {{ $t('autoRotate') }}
          </h4>
          <p>
            {{ $t('modelFunction') }}
          </p>
        </div>
  
        <div class="paragraph-steps">
          <h4>
            {{ $t('deletingObjects') }}
          </h4>
          <p>
            {{ $t('deleteAnObject') }}
          </p>
        </div>
        <div class="i-block">
          <div class="i-block-info">
            <div class="i-block-info-icon">
              <div class="info-icon-background">
                <div class="info-icon-text">
                  {{ $t('i') }}
                </div>
              </div>
            </div>
            <div class="i-block-info-text">
              {{ $t('youCanUseKeyboard') }}
            </div>
          </div>
        </div>
      </div>
      <div id="furniture" ref="furniture" class="sub-paragraph-block">
        <h3 id="furnitDecorBathEquipOther">
          {{ $t('furnitDecorBathEquipOther') }}
        </h3>
        <p>
          {{ $t('modelDragScene') }}
        </p>
        <p>
          {{ $t('generalOptionsModels') }}
        </p>
        <img
          :src="`${staticUrl}/images/interior-design-12.webp`"
          alt=""
          class="article-image mt-5 mb-5"
        />
      </div>
      <div
        id="decor_picture"
        ref="decor_picture"
        class="sub-paragraph-block"
      >
        <h3 id="decorHeadWithoutNumber">
          {{ $t('decorHeadWithoutNumber') }}
        </h3>
        <p>
          {{ $t('decorHeadDesc') }}
        </p>
        <p>
          {{ $t('decorDesc') }}
        </p>
        <div v-if="locale === 'ru'" class="image-carousel">
          <ImagesCustomSlider
          :height="null"
            width="100%"
            :images="[
              `${staticUrl}/images/interior-design-30-1.webp`,
              `${staticUrl}/images/interior-design-30-2.webp`,
              `${staticUrl}/images/interior-design-30-3.webp`,
            ]"
          />
        </div>
        <div v-else class="image-carousel">
          <ImagesCustomSlider
          :height="null"
            width="100%"
            :images="[
              `${staticUrl}/images/interior-design-en-30-1.webp`,
              `${staticUrl}/images/interior-design-en-30-2.webp`,
              `${staticUrl}/images/interior-design-en-30-3.webp`,
            ]"
          />
        </div>
      </div>
      <div ref="lighting" class="sub-paragraph-block">
        <h3 id="lighting">
          {{ $t('lighting') }}
        </h3>
        <p>
          {{ $t('lightingDreamFlat') }}
        </p>
        <div class="paragraph-steps">
          <h4>
            {{ $t('freeLightSources') }}
          </h4>
          <p>
            {{ $t('installLightSources') }}
          </p>
          <p>
            {{ $t('dragAnySource') }}
          </p>
          <div class="i-block">
            <div class="i-block-info">
              <div class="i-block-info-icon">
                <div class="info-icon-background">
                  <div class="info-icon-text">
                    {{ $t('important') }}
                  </div>
                </div>
              </div>
              <div class="i-block-info-text">
                {{ $t('pressL') }}
              </div>
            </div>
          </div>
          <div v-if="locale === 'ru'" class="image-carousel">
            <ImagesCustomSlider
            :height="null"
              width="100%"
              :images="[
                `${staticUrl}/images/interior-design-13-1.webp`,
                `${staticUrl}/images/interior-design-13-2.webp`,
              ]"
            />
          </div>
          <div v-else class="image-carousel">
            <ImagesCustomSlider
            :height="null"
              width="100%"
              :images="[
                `${staticUrl}/images/interior-design-en-13-1.webp`,
                `${staticUrl}/images/interior-design-en-13-2.webp`,
              ]"
            />
          </div>
          <div class="paragraph-steps">
            <h5>
              {{ $t('generalOptionsLight') }}
            </h5>
            <p>
              {{ $t('lightOptions') }}
            </p>
            <div class="step-block">
              <p class="step-element">
                {{ $t('lightOptions1') }}
              </p>
            </div>
            <div class="step-block">
              <p class="step-element">
                {{ $t('lightOptions3') }}
              </p>
              <p class="step-element li">
                ● {{ $t('lightOptionsMetric') }}
              </p>
              <p class="step-element li">● {{ $t('activityMode') }}</p>
              <p class="step-element li">● {{ $t('turnOffLight') }}</p>
            </div>
            <div class="step-block">
              <p class="step-element">
                {{ $t('litArea') }}
              </p>
            </div>
            <div class="step-block">
              <p class="step-element">
                {{ $t('colorTemp') }}
              </p>
              <p class="step-element li">● {{ $t('moveSlider') }}</p>
              <p class="step-element li">● {{ $t('adjustLightColor') }}</p>
              <p class="step-element li">● {{ $t('changeLightTemp') }}</p>
            </div>
            <div class="step-block">
              <p class="step-element">
                {{ $t('lightSource') }}
              </p>
              <p class="step-element li">● {{ $t('iesProfile') }}</p>
              <p class="step-element li">● {{ $t('selectShapeLight') }}</p>
              <p class="step-element li">● {{ $t('shapeIntensity') }}</p>
              <p class="step-element li">
                ● {{ $t('lightSourceRadius') }}
              </p>
              <p class="step-element li">
                ● {{ $t('lightSourceLength') }}
              </p>
            </div>
          </div>
          <div class="paragraph-steps">
            <h4>
              {{ $t('limelight') }}
            </h4>
            <p>
              {{ $t('limelightIsConeShapedLightSource') }}
            </p>
            <p class="mb-5">
              {{ $t('lightDistribution') }}
            </p>
            <img
              :src="`${staticUrl}/images/interior-design-14.webp`"
              alt=""
              class="article-image"
            />
          </div>
          <div class="paragraph-steps">
            <h4>
              {{ $t('rectangularLight') }}
            </h4>
            <p>
              {{ $t('availableInTheLightSource') }}
            </p>
            <p class="mb-5">
              {{ $t('additionallyAdjustTheLengthRectangularLight') }}
            </p>
            <img
              :src="`${staticUrl}/images/interior-design-15.webp`"
              alt=""
              class="article-image"
            />
          </div>
          <div class="paragraph-steps">
            <h4 class="mb-5">
              {{ $t('spotLight') }}
            </h4>
            <p class="mb-5">
              {{ $t('spotLightIsLight') }}
            </p>
            <img
              :src="`${staticUrl}/images/interior-design-16.webp`"
              alt=""
              class="article-image"
            />
          </div>
        </div>
  
        <div class="paragraph-steps">
          <h3 class="mt-10">
            {{ $t('fixturesLampsSpotLightSystems') }}
          </h3>
          <img
            v-if="locale === 'ru'"
            :src="`${staticUrl}/images/interior-design-17.webp`"
            alt=""
            class="article-image"
          />
          <img
            v-else
            :src="`${staticUrl}/images/interior-design-en-17.webp`"
            alt=""
            class="article-image"
          />
          <p>
            {{ $t('spotLightSystemsInYourProject') }}
          </p>
          <p>
            {{ $t('lightingObjectToYourScene') }}
          </p>
          <div class="paragraph-steps">
            <div class="step-block">
              <p class="step-element">
                {{ $t('availableForLightingObjects') }}
              </p>
            </div>
            <div class="step-block">
              <p class="step-element">
                {{ $t('lightOptions3') }}
              </p>
              <p class="li">
                ● {{ $t('activityModeChooseWhenLightBeOn') }}
              </p>
              <p class="li">
                ● {{ $t('turnOffTheLightObject') }}
              </p>
            </div>
            <div class="step-block">
              <p class="step-element">
                {{ $t('litArea') }}
              </p>
              <p class="li">
                ● {{ $t('chooseDisplayLitArea') }}
              </p>
            </div>
            <div class="step-block">
              <p class="step-element">
                {{ $t('colorTemp') }}
              </p>
              <p class="li">● {{ $t('moveSlider') }}</p>
              <p class="li">● {{ $t('adjustLightColor') }}</p>
              <p class="li">● {{ $t('changeLightTemp') }}</p>
            </div>
          </div>
        </div>
      </div>
      <div ref="kitchen" class="sub-paragraph-block">
        <h3
        id="kitchen"
        >
          {{ $t('kitchen') }}
        </h3>
        <p class="sub-paragraph-text">
          {{ $t('preMadeKitchens') }}
        </p>
        <div class="paragraph-steps">
          <h4>
            {{ $t('preDesignedKitchens') }}
          </h4>
          <p class="mb-5">
            {{ $t('designedKitchensAvailableInTheLibrary') }}
          </p>
          <img
            v-if="locale === 'ru'"
            :src="`${staticUrl}/images/interior-design-18.webp`"
            alt=""
            class="article-image"
          />
          <img
            v-else
            :src="`${staticUrl}/images/interior-design-en-18.webp`"
            alt=""
            class="article-image"
          />
        </div>
        <div class="paragraph-steps">
          <h4 class="mt-5">
            {{ $t('modularKitchens') }}
          </h4>
          <div class="step-block">
            <p class="step-element">
              {{ $t('canCreateKitchenUsingKitchenModules') }}
            </p>
            <p class="step-element">
              {{ $t('fridgeEtcAreAvailable') }}
            </p>
            <p class="step-element">
              {{ $t('whereYouCanConfigureTheObjectParameters') }}
            </p>
          </div>
  
          <img
            v-if="locale === 'ru'"
            :src="`${staticUrl}/images/interior-design-18-2.webp`"
            alt=""
            class="article-image"
          />
          <img
            v-else
            :src="`${staticUrl}/images/interior-design-en-18-2.webp`"
            alt=""
            class="article-image"
          />
          <div class="paragraph-steps">
            <h5>
              {{ $t('generalOptionsForKitchenModules') }}
            </h5>
            <div class="step-block">
              <p class="step-element">
                {{ $t('theyCanBeMovedRotated') }}
              </p>
              <p class="step-element">
                {{ $t('autoRotationKitchenDefault') }}
              </p>
              <p class="step-element">
                {{ $t('alignmentWillAllowAutomaticallyPlace') }}
              </p>
              <p class="step-element">
                {{ $t('changingTheObjectDimensions') }}
              </p>
            </div>
          </div>
          <div class="paragraph-steps">
            <h5>
              {{ $t('bottomModules') }}
            </h5>
            <div class="step-block">
              <p class="step-element">
                {{ $t('adjustTheColourAndTypeFrontSurface') }}
              </p>
            </div>
            <div class="i-block">
              <div class="i-block-info">
                <div class="i-block-info-icon">
                  <div class="info-icon-background">
                    <div class="info-icon-text">
                      {{ $t('i') }}
                    </div>
                  </div>
                </div>
                <div class="i-block-info-text">
                  {{ $t('colourWillBeApplied') }}
                </div>
              </div>
            </div>
            <div class="i-block">
              <div class="i-block-info">
                <div class="i-block-info-icon">
                  <div class="info-icon-background">
                    <div class="info-icon-text">
                      {{ $t('i') }}
                    </div>
                  </div>
                </div>
                <div class="i-block-info-text">
                  {{ $t('frontSurfaceApplySelectedModule') }}
                </div>
              </div>
            </div>
            <div class="step-block">
              <p class="step-element">
                {{ $t('customizeTheProfileMaterial') }}
              </p>
            </div>
            <div class="i-block">
              <div class="i-block-info">
                <div class="i-block-info-icon">
                  <div class="info-icon-background">
                    <div class="info-icon-text">
                      {{ $t('i') }}
                    </div>
                  </div>
                </div>
                <div class="i-block-info-text">
                  {{ $t('colourWillBeAppliedToAll') }}
                </div>
              </div>
            </div>
            <div class="step-block">
              <p class="step-element">
                {{ $t('customizeThePlinthMaterial') }}
              </p>
            </div>
            <div class="i-block">
              <div class="i-block-info">
                <div class="i-block-info-icon">
                  <div class="info-icon-background">
                    <div class="info-icon-text">
                      {{ $t('i') }}
                    </div>
                  </div>
                </div>
                <div class="i-block-info-text">
                  {{ $t('colourWillBeAppliedToAll') }}
                </div>
              </div>
            </div>
            <div class="step-block">
              <p class="step-element">
                {{ $t('selectCountertopMaterial') }}
              </p>
              <p class="step-element">
                {{ $t('selectTheMaterial') }}
              </p>
              <p class="step-element">
                {{ $t('DisplayBoxToHideCountertop') }}
              </p>
              <p class="step-element">
                {{ $t('overhangCountertop') }}
              </p>
              <p class="step-element">
                {{ $t('selectYourWashBasin') }}
              </p>
              <p class="step-element">
                {{ $t('selectCookingSurface') }}
              </p>
            </div>
            <img
              :src="`${staticUrl}/images/interior-design-19.webp`"
              alt=""
              class="article-image"
            />
          </div>
          <div class="paragraph-steps">
            <h5>
              {{ $t('tallUnit') }}
            </h5>
            <div class="step-block">
              <p class="step-element">
                {{ $t('adjustTheColourAndTypeFrontSurface') }}
              </p>
              <p class="step-element">
                {{ $t('customizeThePlinthMaterialAssign') }}
              </p>
            </div>
            <img
              :src="`${staticUrl}/images/interior-design-20.webp`"
              alt=""
              class="article-image"
            />
          </div>
          <div class="paragraph-steps">
            <h5>
              {{ $t('fridge') }}
            </h5>
            <div class="step-block">
              <p class="step-element">
                {{ $t('adjustTheColourAndTypeFrontSurface') }}
              </p>
              <p class="step-element">
                {{ $t('customizeThePlinthMaterialAssign') }}
              </p>
            </div>
            <img
              :src="`${staticUrl}/images/interior-design-21.webp`"
              alt=""
              class="article-image"
            />
          </div>
          <div class="paragraph-steps">
            <h5>
              {{ $t('upperWallModules') }}
            </h5>
            <div class="step-block">
              <p class="step-element">
                {{ $t('changeHeightUpperWall') }}
              </p>
              <p class="step-element">
                {{ $t('selectMaterialColorUpperWall') }}
              </p>
            </div>
            <img
              :src="`${staticUrl}/images/interior-design-22.webp`"
              alt=""
              class="article-image"
            />
          </div>
          <div class="paragraph-steps">
            <h5 class="mb-5">
              {{ $t('lowerWallModules') }}
            </h5>
            <div>
              <p>
                {{ $t('changeHeightLowerWall') }}
              </p>
              <p class="mb-5">
                {{ $t('selectMaterialColorLowerWall') }}
              </p>
            </div>
            <img
              v-if="locale === 'ru'"
              :src="`${staticUrl}/images/interior-design-23.webp`"
              alt=""
              class="article-image"
            />
            <img
              v-else
              :src="`${staticUrl}/images/interior-design-en-23.webp`"
              alt=""
              class="article-image"
            />
          </div>
        </div>
      </div>
    </div>
    <div ref="primitives" class="paragraph-block">
      <h3 id="primitives">
        {{ $t('primitives') }}
      </h3>
      <div class="i-block">
        <div class="i-block-info">
          <div class="i-block-info-icon">
            <div class="info-icon-background">
              <div class="info-icon-text">
                {{ $t('premiium') }}
              </div>
            </div>
          </div>
          <div class="i-block-info-text">
            {{ $t('premiumSubscribersAccessPrimitives') }}
          </div>
        </div>
      </div>
      <p class="paragraph-text">
        {{ $t('primitivesSetsGeometricShapes') }}
      </p>
      <p class="paragraph-text">
        {{ $t('usePrimitive') }}
      </p>
      <div class="step-block">
        <p class="li">
          {{ $t('generalOptionsSceneModels') }}
        </p>
        <p class="li">
          {{ $t('changingDimensions') }}
        </p>
        <p class="li">
          {{ $t('assignMaterialPrimitive') }}
        </p>
        <p class="li">
          {{ $t('primitiveType') }}
        </p>
      </div>
      <p class="paragraph-text">
        {{ $t('humanFiguresAvailablePrimitives') }}
      </p>
      <p class="paragraph-text">
        {{ $t('seeTutorialUsingPrimitives') }}
      </p>
      <div v-if="locale === 'ru'" class="video-frame">
        <iframe
          width="100%"
          height="419"
          src="https://www.youtube.com/embed/KTfR9BHyQ4E"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        />
      </div>
      <div v-else class="video-frame">
        <iframe
          width="100%"
          height="419"
          src="https://www.youtube.com/embed/uS0Hkc_werE"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        />
      </div>
    </div>
    <div id="user-objects" ref="user-objects" class="paragraph-block">
      <h3 class="mt-10" id="customObjectsWithoutNumber">
        {{ $t('customObjectsWithoutNumber') }}
      </h3>
      <p>
        {{ $t('preMadeKitchens') }}
      </p>
      <div class="i-block">
        <div class="i-block-info">
          <div class="i-block-info-icon">
            <div class="info-icon-background">
              <div class="info-icon-text">
                {{ $t('designerPlus') }}
              </div>
            </div>
          </div>
          <div class="i-block-info-text">
            {{ $t('designerHaveOptionUploadingModels') }}
          </div>
          <div class="i-block-info-text">
            {{ $t('uploadModelsWithCustomizableElements') }}
          </div>
        </div>
      </div>
      <div
        id="user-objects-model"
        ref="user-objects-model"
        class="sub-paragraph-block"
      >
        <h4>
          {{ $t('customModel') }}
        </h4>
        <div class="paragraph-steps">
          <h5>
            {{ $t('addingModel') }}
          </h5>
        </div>
        <p class="paragraph-text">
          {{ $t('instuctionAddingModel') }}
        </p>
        <p class="paragraph-text">
          {{ $t('importModelDialog2') }}
        </p>
        <p class="paragraph-text">
          {{ $t('uploadedModelAppearCustomObjects') }}
        </p>
        <p class="paragraph-text">
          {{ $t('watchVideoHowAddOwnModel') }}
        </p>
        <div v-if="locale === 'ru'" class="video-frame">
          <iframe
            width="100%"
            height="419"
            src="https://www.youtube.com/embed/vabfHtq7LcM"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          />
        </div>
        <div v-else class="video-frame">
          <iframe
          width="100%"
            height="419"
            src="https://www.youtube.com/embed/SRgADmRhiXA"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          />
        </div>
        <div class="paragraph-steps">
          <h5>
            {{ $t('modifyingCustomModelAddedScene') }}
          </h5>
          <p class="paragraph-text">
            {{ $t('optionsSceneObjectsAreAvailableCustomModels') }}
          </p>
          <p class="paragraph-text">
            {{ $t('additionalFunctionsAvailableModels') }}
          </p>
          <div class="step-block">
            <p class="step-element">
              {{ $t('autoRotateThisModelFunction') }}
            </p>
          </div>
        </div>
        <div class="i-block">
          <div class="i-block-info">
            <div class="i-block-info-icon">
              <div class="info-icon-background">
                <div class="info-icon-text">
                  {{ $t('important') }}
                </div>
              </div>
            </div>
            <div class="i-block-info-text">
              {{
                $t(
                  'changeDimensionsCustomisableElementsModelAfterUploading',
                )
              }}
            </div>
          </div>
        </div>
      </div>
      <div
        id="user-objects-material"
        ref="user-objects-material"
        class="sub-paragraph-block"
      >
        <h4>
          {{ $t('customMaterial') }}
        </h4>
          <h5 class="mb-5">
            {{ $t('addMaterial') }}
          </h5>
        <p>
          {{ $t('addedToLibrary') }}
        </p>
        <p class="paragraph-text">
          {{ $t('addedToLibraryInstr') }}
        </p>
        <p class="paragraph-text">
          {{ $t('addedToLibraryInstr2') }}
        </p>
        <p class="paragraph-text">
          {{ $t('addedToLibraryInstr3') }}
        </p>
        <p class="paragraph-text">
          {{ $t('addedToLibraryInstrVideo') }}
        </p>
        <div v-if="locale === 'ru'" class="video-frame">
          <iframe
            width="100%"
            height="419"
            src="https://www.youtube.com/embed/wpKSkpwBKm4"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          />
        </div>
        <div v-else class="video-frame">
          <iframe
            width="100%"
            height="419"
            src="https://www.youtube.com/embed/neywOAyRtXU"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          />
        </div>
        <div class="paragraph-steps">
          <h5>
            {{ $t('modifyingCustomMaterial') }}
          </h5>
          <p class="paragraph-text">
            {{ $t('sceneMaterialsAvailableForCustomMaterials') }}
          </p>
        </div>
      </div>
    </div>
    <div class="paragraph-block">
      <h3
        id="doorsAndWindows"
        ref="doors-and-windows"
      >
        {{ $t('doorsAndWindows') }}
      </h3>
      <div class="sub-paragraph-block">
        <h4>
          {{ $t('doors') }}
        </h4>
        <div class="paragraph-steps">
          <p>{{ $t('doorsAndWindowsT1')}}</p>
          <p class="paragraph-text">
            {{ $t('modifyDoor') }}
          </p>
          <p class="paragraph-text">
            {{ $t('followingParametersDoors') }}
          </p>
          <div>
            <p class="step-element">
              {{ $t('DoorAndFrameDisplay') }}
            </p>
            <p class="step-element">
              {{ $t('directionDoorOpeningHandlePosition') }}
            </p>
            <p class="step-element">
              {{ $t('offset') }}
            </p>
            <p class="step-element">
              {{ $t('useElementsAdjustColourMaterial') }}
            </p>
          </div>
          <p class="paragraph-text">
            {{ $t('moreAboutDoor') }}
          </p>
        </div>
        <img
          v-if="locale === 'ru'"
          :src="`${staticUrl}/images/interior-design-24.webp`"
          alt=""
          class="article-image"
        />
        <img
          v-else
          :src="`${staticUrl}/images/interior-design-en-24.webp`"
          alt=""
          class="article-image"
        />
        <div class="sub-paragraph-block">
          <h4 id="windows" ref="windows" class="mb-5">
            {{ $t('windows') }}
          </h4>
          <div class="mb-5">
            <p class="paragraph-text">
              {{ $t('modifyWindow') }}
            </p>
            <p class="paragraph-text">
              {{ $t('setFollowingParametersWindows') }}
            </p>
            <div class="step-block">
              <p class="step-element">
                {{ $t('displayedHandles') }}
              </p>
              <p class="step-element">
                {{ $t('numberOpeningSections') }}
              </p>
              <p class="step-element">
                {{ $t('offset') }}
              </p>
              <p class="step-element">
                {{ $t('useElementsAdjustColourMaterial2') }}
              </p>
            </div>
            <p class="paragraph-text">
              {{ $t('moreAboutWindows') }}
            </p>
          </div>
          <img
            v-if="locale === 'ru'"
            :src="`${staticUrl}/images/interior-design-25.webp`"
            alt=""
            class="article-image"
          />
          <img
            v-else
            :src="`${staticUrl}/images/interior-design-en-25.webp`"
            alt=""
            class="article-image"
          />
        </div>
      </div>
    </div>
    <div>
      <h2>
        {{ $t('RObjectBr') }}
      </h2>
      <h3 id="workingWithObjects">
        {{ $t('workingWithObjects') }}
      </h3>
      <h4>{{ $t('workingWithObjects')}}</h4>
      <p>
        {{ $t('workingWithObjectsT1') }}
      </p>
      <p>
        {{ $t('workingWithObjectsT2') }}
      </p>
      <p>
        {{ $t('workingWithObjectsT3') }}
      </p>
      <h4>{{ $t('workingWithObjectsT4')}}</h4>
      <p>{{ $t('workingWithObjectsT5') }}</p>
      <p>{{ $t('workingWithObjectsT6') }}</p>
      <p>{{ $t('workingWithObjectsT7') }}</p>
      <h4>{{ $t('workingWithObjectsT8') }}</h4>
      <p>{{ $t('workingWithObjectsT9') }}</p>
      <p>{{ workingWithObjectsT10[0]}}
        <ui-link
        class="link"
        to="https://www.unrealengine.com/en-US/datasmith/plugins"
      >{{workingWithObjectsT10[1]}}</ui-link>{{workingWithObjectsT10[2]}}</p>
      <p>{{ $t('workingWithObjectsT11') }}</p>
      <p>{{ $t('workingWithObjectsT12') }}</p>
      <p>{{ $t('workingWithObjectsT13') }}</p>
    </div>
    <div
      id="save-change-open"
      ref="save-change-open"
      class="paragraph-block"
    >
      <h2>
        {{ $t('SavingAndReopeningAProject') }}
      </h2>
      <div class="sub-paragraph-block">
        <h3 class="sub-paragraph-title" id="savingDes">
          {{ $t('savingDes') }}
        </h3>
        <p class="mb-5">
          {{ $t('saveProjectInstruction') }}
        </p>
        <img
          v-if="locale === 'ru'"
          :src="`${staticUrl}/images/interior-design-26.webp`"
          alt=""
          class="article-image"
        />
        <img
          v-else
          :src="`${staticUrl}/images/interior-design-en-26.webp`"
          alt=""
          class="article-image"
        />
        <div class="i-block">
          <div class="i-block-info">
            <div class="i-block-info-icon">
              <div class="info-icon-background">
                <div class="info-icon-text">
                  {{ $t('i') }}
                </div>
              </div>
            </div>
            <div class="i-block-info-text">
              {{ $t('designSavedAutomatically') }}
            </div>
          </div>
        </div>
        <div class="i-block">
          <div class="i-block-info">
            <div class="i-block-info-icon">
              <div class="info-icon-background">
                <div class="info-icon-text">
                  {{ $t('important') }}
                </div>
              </div>
            </div>
            <div class="i-block-info-text">
              {{ $t('ifEditedDesignCreatedEarlierTwoOptionsSaving') }}
            </div>
            <div class="i-block-info-text">
              {{ $t('designReplacePreviousVersionInstructions') }}
            </div>
            <div class="i-block-info-text">
              {{ $t('saveCurrentDesign') }}
            </div>
          </div>
        </div>
      </div>
      <div class="sub-paragraph-block">
        <h3 id="replacingDesignVersion">
          {{ $t('replacingDesignVersion') }}
        </h3>
        <p class="paragraph-text">
          {{ $t('switchDesignMode') }}
        </p>
        <div class="i-block">
          <div class="i-block-info">
            <div class="i-block-info-icon">
              <div class="info-icon-background">
                <div class="info-icon-text">
                  {{ $t('important') }}
                </div>
              </div>
            </div>
            <div class="i-block-info-text">
              {{ $t('saveDesignSeveralVersion') }}
            </div>
          </div>
        </div>
      </div>
  
      <div class="sub-paragraph-block">
        <h3 id="reOpeningDesign">
          {{ $t('reOpeningDesign') }}
        </h3>
        <p class="mb-5">
          {{ $t('continueWorkingSavedDesign') }}
        </p>
        <img
          v-if="locale === 'ru'"
          :src="`${staticUrl}/images/interior-design-28.webp`"
          alt=""
          class="article-image"
        />
        <img
          v-else
          :src="`${staticUrl}/images/interior-design-en-28.webp`"
          alt=""
          class="article-image"
        />
      </div>
    </div>
    <h3 class="mt-10" id="publicationPublicDomain">
      {{ $t('publicationPublicDomain') }}
    </h3>
    <p>{{ $t('publicationPublicDomainT1')}}</p>
    <img
          v-if="locale === 'ru'"
          :src="`${staticUrl}/images/help-center/hc-publicationPublicDomain-ru.webp`"
          alt=""
          class="article-image"
        />
        <img
          v-else
          :src="`${staticUrl}/images/help-center/hc-publicationPublicDomain-en.webp`"
          alt=""
          class="article-image"
        />
  </div>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';
import { getTranslateBySpanTag } from '~/helpers/baseFunction';

const {locale, t} = useI18n();
const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;

const workingWithObjectsT10 = computed(() =>
  getTranslateBySpanTag(t('workingWithObjectsT10')),
);
</script>

<style scoped lang="scss">
@import 'css/help-center/help-center-general-ctyle';
</style>
